import { Controller } from "@hotwired/stimulus"

// Marks a Leads / Waiting List row as seen on any click within it: the unread
// dot disappears immediately and the visit is persisted so it stays cleared.
// keepalive lets the POST survive a click that also navigates (row-link).
export default class extends Controller {
  static targets = ["dot"]
  static values = { url: String }

  record() {
    if (!this.hasDotTarget) return

    this.dotTargets.forEach((dot) => dot.remove())
    fetch(this.urlValue, {
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      keepalive: true,
      method: "POST",
    })
  }
}
